module.exports = __webpack_public_path__ + "df0cda7a141bd1f5f8a04dc1993b3006.svg";